export interface Version {
  date: string
  label: string
  text: string
}

export const versionHistory: Record<
  string,
  {
    versions: Version[]
    objections: string
    source: string
  }
> = {
  '5': {
    versions: [
      {
        date: 'January 12, 2025',
        label: 'Original Response',
        text: 'Objection. This interrogatory is compound, vague, ambiguous, and overly broad. It seeks information protected by the attorney-client privilege, work product doctrine, and trade secret privilege. Responding Party further objects that this interrogatory is not reasonably calculated to lead to the discovery of admissible evidence. Without waiving said objections, Responding Party states that it denies the material allegations referenced herein.',
      },
      {
        date: 'March 28, 2025',
        label: 'After Meet and Confer',
        text: "Subject to and without waiving the objections stated in the original response, and pursuant to the parties' meet and confer agreement dated March 15, 2025, Responding Party supplements as follows: Responding Party admits that it received the shipment of Model X-100 units on or about October 5, 2020. Responding Party denies that it had knowledge of any alleged defect at the time of receipt. Responding Party lacks sufficient information to admit or deny the remaining allegations and on that basis denies them.",
      },
      {
        date: 'June 14, 2025',
        label: 'Amended',
        text: "Pursuant to the Court's Order dated May 30, 2025 compelling further responses, Responding Party states as follows: Responding Party received a shipment of 2,400 Model X-100 units from Pacific Industries on October 5, 2020 at its distribution facility located at 1847 Commerce Drive, Long Beach, California. Prior to distribution, Responding Party's receiving department conducted a standard intake inspection pursuant to SOP-REC-401. During this inspection, warehouse supervisor Michael Torres noted that approximately 340 units exhibited minor cosmetic damage to the outer packaging. This was documented in Receiving Report No. RR-2020-1847, a copy of which has been produced at Bates No. SMITH-003421. Responding Party did not conduct any further testing or inspection of the units beyond the standard intake process. The units were subsequently distributed to retail partners between October 12, 2020 and November 3, 2020, as reflected in the shipping manifests produced at Bates Nos. SMITH-003450 through SMITH-003512.",
      },
    ],
    objections:
      'Responding Party objects to this interrogatory on the grounds that it is vague, ambiguous, overly broad, unduly burdensome, and seeks information protected by the attorney-client privilege and work product doctrine. Responding Party further objects that the interrogatory is compound and contains subparts in excess of the number permitted under applicable rules. Subject to and without waiving these objections, Responding Party responds as follows.',
    source: 'Defendant_2_Responses_Set_3.pdf — Page 14',
  },
  '10': {
    versions: [
      {
        date: 'February 10, 2025',
        label: 'Original Response',
        text: 'Objection. Assumes facts not in evidence and mischaracterizes the nature of the redesign. The premise of the question is flawed as there was no formal "redesign" in 2021.',
      },
      {
        date: 'April 5, 2025',
        label: 'Amended',
        text: 'Objection. Assumes facts not in evidence and mischaracterizes the nature of the redesign. The polymer was selected for its superior thermal resistance properties.',
      },
    ],
    objections: 'Standard objections incorporated by reference.',
    source: 'Defendant_1_Responses_Set_3.pdf — Page 8',
  },
  '19': {
    versions: [
      {
        date: 'January 20, 2025',
        label: 'Original Response',
        text: 'Objection. Vague and ambiguous as to "marketing materials". Responding Party lacks sufficient information to answer at this time.',
      },
      {
        date: 'March 1, 2025',
        label: 'Amended',
        text: 'The marketing materials were approved by the joint marketing committee, comprising representatives from both Smith Holdings and Acme Corp.',
      },
    ],
    objections: 'Standard objections incorporated by reference.',
    source: 'Defendant_2_Responses_Set_1.pdf — Page 12',
  },
  '24': {
    versions: [
      {
        date: 'May 12, 2025',
        label: 'Original Response',
        text: 'Approximately 10,000 units.',
      },
      {
        date: 'June 30, 2025',
        label: 'Amended',
        text: 'Approximately 14,500 units.',
      },
    ],
    objections: 'Standard objections incorporated by reference.',
    source: 'Defendant_3_Responses_Set_3.pdf — Page 21',
  },
}

export function getVersions(
  rowId: string,
  fallbackResponse: string,
  fallbackParty: string,
  fallbackSet: string,
) {
  return (
    versionHistory[rowId] || {
      versions: [
        {
          date: 'Current',
          label: 'Response',
          text: fallbackResponse || 'No response provided.',
        },
      ],
      objections: 'Standard objections incorporated by reference.',
      source: `${fallbackParty.split('—')[0].trim().replace(/ /g, '_')}_Responses_${fallbackSet.replace(/ /g, '_')}.pdf`,
    }
  )
}
